import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, VIRTUAL_PAGEVIEWS as PAGES } from '@sm360/widget-commons-general';
import { Quote } from '@sm360/widget-commons-vehicle';

import FacebookAuthenticationService from 'login/services/FacebookAuthenticationService/FacebookAuthenticationService.js';

import 'login/components/Library/FacebookBtn/FacebookBtn.scss';

class FacebookBtn extends React.Component {
    constructor(props) {
        super(props);

        this.text = LocaleService.t('LOGIN.LOGIN_SOCIAL_FB');
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation();
        e.preventDefault();

        WindowProxy.getFBApi().login(
            (response) => {
                if (response && response.authResponse) {
                    AnalyticsService.virtualPageView(PAGES.FB_CONNECT());

                    FacebookAuthenticationService.authenticate(
                        response.authResponse.accessToken,
                        this.props.quote
                    ).then(this.props.closeDialog, this.props.closeDialog);
                }
            },
            {
                scope: 'email',
            }
        );
    }

    render() {
        return (
            <div className="form-login">
                <button
                    className="button-social-fb button"
                    onClick={this.handleClick}
                    data-test="login.facebook.authentication"
                >
                    <icon className="icon-facebook" />
                    <span>{this.text}</span>
                </button>
            </div>
        );
    }
}
FacebookBtn.defaultProps = {
    quote: new Quote.QuoteModel(),
};

FacebookBtn.propTypes = {
    closeDialog: PropTypes.func.isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
};

FacebookBtn.displayName = 'FacebookBtn';

export default FacebookBtn;



// WEBPACK FOOTER //
// ./src/components/Library/FacebookBtn/FacebookBtn.jsx